<p>reportmenu works!</p>
